import Cookies from "js-cookie";

const gaProperty = "G-8ESGBTGV49";

var disableStr = "ga-disable-" + gaProperty;
if (document.cookie.indexOf(disableStr + "=true") > -1) {
  window[disableStr] = true;
}

function gaOptout() {
  document.cookie =
    disableStr + "=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/";
  window[disableStr] = true;
}

window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}
window.gtag = gtag;

/**
 * @param {string} mode ["default" | "update"]
 * @see https://developers.google.com/gtagjs/devguide/consent
 *
 * The deafault mode should be called first, any changes should use the
 * update mode.
 */
window.setGtagConsent = (mode) => {
  const CookieConsent = JSON.parse(
    Cookies.get("good_travel_cookie_consent") || "{}",
  );

  const allowedRequired = CookieConsent?.required ? "granted" : "denied";
  const allowedStatistics = CookieConsent?.statistics ? "granted" : "denied";
  const allowedMarketing = CookieConsent?.marketing ? "granted" : "denied";

  gtag("consent", mode, {
    // Enables storage (such as cookies) related to advertising.
    ad_storage: allowedMarketing,
    // Sets consent for sending user data related to advertising to Google.
    ad_user_data: allowedMarketing,
    // Sets consent for personalized advertising.
    ad_personalization: allowedMarketing,
    // Enables storage (such as cookies) related to analytics e.g. visit duration.
    analytics_storage: allowedStatistics,
    // Enables storage that supports the functionality of the website or app e.g. language settings.
    functionality_storage: allowedRequired,
    // Enables storage related to personalization e.g. video recommendations
    personalization_storage: allowedMarketing,
    // Enables storage related to security such as authentication functionality, fraud prevention, and other user protection.
    security_storage: allowedRequired,
  });
};

window.setGtagConsent("default");

gtag("js", new Date());
gtag("set", "ads_data_redaction", true);
gtag("set", "url_passthrough", true);
gtag("config", "G-8ESGBTGV49");
